import React, {Component} from "react";
import {langFromLocale} from "../../../helpers";
import { withRouter } from "react-router-dom";
import { cloneDeep } from "lodash";
import { getFormatConfigData, getCheckoutLineId, getConfigurablePlanPdfUrl } from '../utils'
import { config } from 'chai'
import { removeCartLine } from '../../../store/cart/actions'

class ConfigurableCutToSize extends Component {

    constructor(props, context) {
        super(props, context);

        const lang = langFromLocale[this.props.intl.locale]
        this.state = {
            language: lang
        }
    }

    componentDidMount() {
        const cosConfigurable = document.querySelector('cos-configurable')
        if (cosConfigurable) {
            cosConfigurable.addEventListener('salida', (config) => {
                this.handleSalidaEvent(config)
            })
        }
        
        this.props.setIsConfigurableBathEditScreen(true)
    }
    
    componentWillUnmount() {
        this.props.setIsConfigurableBathEditScreen(false)
    }

    handleSalidaEvent = (config) => {
        const { localizedUrl, history, configurablePlanAcceptanceList } = this.props
        let configDetail = config && config.detail

        if (!Array.isArray(configDetail)) {configDetail = [configDetail]}
        let refcode = configDetail[0] && configDetail[0].parentReference
        if (!refcode) refcode = configDetail[0] && configDetail[0].reference

        // Determine if the plan has been accepted
        const isPlanAccepted = configurablePlanAcceptanceList
                                && configurablePlanAcceptanceList[refcode]
                                && configurablePlanAcceptanceList[refcode].isPlanAcceptanceChecked

        // Check if the configuration has been modified
        const isModified = this.isConfigModified(configDetail)

        if (isPlanAccepted && !isModified) {
            const routePath = localizedUrl('ROUTE_CHECKOUT')
            history.push(routePath)
        } else {
            this.handlePlanAcceptance(configDetail)
        }
    }

    isConfigModified = (configDetail) => {
        const { configurableInProgress } = this.props

        // Ensure that configurableInProgress and config.detail exist
        let storeConfig = null
        let reference = null
        const currentConfig = cloneDeep(configDetail)

        if (Array.isArray(currentConfig)) {
            reference = currentConfig[0].parentReference
            if (!reference) reference = currentConfig[0].reference
            storeConfig = configurableInProgress[reference]
            currentConfig.forEach((item) => {
                delete item.price
                delete item.quantity
                if (item.configuration) delete item.configuration.quantity
                if (storeConfig) {
                    if (!storeConfig.find(config => config.reference === item.reference)) {
                        this.props.addAddedConfigurable(item.reference)
                    }
                }
            })
        }

        if (Array.isArray(storeConfig)) {
            storeConfig.forEach((item) => {
                delete item.price
                delete item.quantity
                if (item.configuration) delete item.configuration.quantity
                if (!currentConfig.find(config => config.reference === item.reference)) {
                    this.props.addDeletedConfigurable(item.reference)
                }
            })
        }

        const isModified = storeConfig && JSON.stringify(storeConfig) !== JSON.stringify(currentConfig)
        // console.log('stringify >>>>>>>>>>> ', storeConfig, currentConfig)

        // Update global state
        if (reference) {
            this.props.addConfigurableModifiedList(reference, isModified)
            if (isModified) this.props.addConfigurablePlanAcceptanceChecked(reference, false)
        }
        
        return isModified
    }

    handlePlanAcceptance = (configDetail) => {
        const { history, localizedUrl, model, type, fabricator } = this.props

        if (!Array.isArray(configDetail)) {configDetail = [configDetail]}
        let refcode = configDetail[0] && configDetail[0].parentReference
        if (!refcode) refcode = configDetail[0] && configDetail[0].reference

        this.props.addConfigurableInProgress(refcode, configDetail).then(() => {
            console.log('** handlePlanAcceptance >', refcode)

            const routePath = localizedUrl('ROUTE_CONFIG_CUT_TO_SIZE_PLAN_ACCEPTANCE')
                                .replace(':type', type)
                                .replace(':model', model)
                                .replace(':fabricator', fabricator)
                                .replace(':refcode', refcode)

            history.push(routePath)
        })
    }

    getFormattedData = (configDetail) => {
        const { refcode, configurablePlanAcceptanceList, intl, units, configurableDrawingList } = this.props

        const isPlanAccepted = configurablePlanAcceptanceList &&
        configurablePlanAcceptanceList[refcode] &&
        configurablePlanAcceptanceList[refcode].isPlanAcceptanceChecked

        return getFormatConfigData(configDetail, isPlanAccepted, intl.locale, units, getConfigurablePlanPdfUrl(configurableDrawingList, refcode), refcode)
    }

    getCurrentConfigQuantity = () => {
        const { refcode, configurableInProgress } = this.props
        const currentConfig = refcode && configurableInProgress[refcode]

        return currentConfig && parseInt(currentConfig.quantity)
    }

    getUserCurrency = () => {
        const { priceListAtSelectedCenter } = this.props
        const currency = priceListAtSelectedCenter && priceListAtSelectedCenter.length > 0 ? priceListAtSelectedCenter[0].currency : null

        return currency
    }

    render() {
        const { model, refcode, username, salesOrg, selectedCenter, type, intl, localeSelected } = this.props
        const isQuickShip = this.props.fabricator === 'local'
        const saveConfigUrl = process.env.REACT_APP_REDIRECT_URI ? `${process.env.REACT_APP_REDIRECT_URI.replace(/\/$/, '')}/${localeSelected}/configuration/favorites` : '';

        return (
            <div>
                <cos-configurable product={type}
                                  model={model.toUpperCase()}
                                  market={this.props.market}
                                  apikey={process.env.REACT_APP_CONFIGURABLES_APIKEY}
                                  callback="callback"
                                  reference={refcode}
                                  lang={this.state.language}
                                  locale={this.state.language}
                                  currency={this.getUserCurrency()}
                                  kunnr={username}
                                  salesOrg={salesOrg}
                                  werks={selectedCenter}
                                  quantity={this.getCurrentConfigQuantity()}
                                  quickship={isQuickShip}
                                  options={true}
                                  save_config={true}
                                  save_config_url={saveConfigUrl}
                                  discounts={false}
                                  toggle_discount={true}
                                  general_conditions_sale={false}
                                  origin={"ECOSENTINO"}
                                  fast_delivery={true} // -> pasar true para activar colores optimizados
                >
                </cos-configurable>
            </div>
        )
    }
}

export default withRouter(ConfigurableCutToSize)